import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const rentalSlice = createSlice({
  name: 'rental',
  initialState,
  reducers: {
    rentalStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent = {}, blockDesign = {} } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent?.items ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign?.view ?? 'feed',
        layout: blockDesign?.layout ?? '1',
      };
    },
    rentalClear: () => initialState,
    rentalUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    rentalUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    rentalUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    rentalUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { rentalStore, rentalClear, rentalUpdateIsLoading, rentalUpdateIsActive, rentalUpdateBlockContent, rentalUpdateBlockDesign } = rentalSlice.actions;

export const selectRentalIsLoading = (state) => state.rental.isLoading;
export const selectRentalId = (state) => state.rental.id;
export const selectRentalUID = (state) => state.rental.uid;
export const selectRentalSID = (state) => state.rental.sid;
export const selectRentalBlockContent = (state) => state.rental.blockContent;
export const selectRentalBlockDesign = (state) => state.rental.blockDesign;
export const selectRentalSortItems = createSelector([selectRentalBlockContent], ({ items }) => items ?? []);
export const selectRentalItemDesign = (state) => state.rental.itemDesign;
export const selectRentalContainerDesign = (state) => state.rental.containerDesign;

export default rentalSlice.reducer;
